import React, { useReducer, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Form as RFForm, Field } from 'react-final-form'

import Form from '@piconetworks/form'
import { colors } from '@piconetworks/functions'
import Boutton from '@piconetworks/boutton'

import Loader from 'common/modules/loader'
import Internal from 'common/modules/internal'
import Arbiter from 'common/modules/arbiter'

import { isEqual } from 'lodash'
import cx from 'classnames'

import styles from './OfferCode.module.scss'

const initState = {
    error: false,
    shortCode: null,
    isVisible: false,
}

const types = {
    base: 'FETCH_POPUP',
    error: 'FETCH_POPUP_ERROR',
    toggle: 'TOGGLE',
    clearError: 'CLEAR_ERROR',
}

const OfferCodeReducer = (state, {
    type, payload: {
        shortCode,
    } = {},
}) => {
    switch (type) {
        case types.base:
            return {
                ...initState,
                isVisible: true,
                shortCode,
            }

        case types.error:
            return {
                ...state,
                error: true,
            }

        case types.clearError:
            return {
                ...state,
                error: false,
            }

        case types.toggle:
            return {
                ...state,
                isVisible: !state.isVisible,
            }

        default:
            return state
    }
}

const OfferCode = () => {
    const dispatch = useDispatch()

    const [{
        error,
        shortCode,
        isVisible,
    }, localDispatch] = useReducer(OfferCodeReducer, { initState })

    const fetchedPopup = useSelector((state) => (
        Loader.selectors.popupGetPopupById(state, shortCode)
    ), isEqual)

    const linkColor = useSelector(Loader.selectors.linkColor)
    const contrastColor = colors.getContrastColor(linkColor)

    useEffect(() => {
        if (fetchedPopup && shortCode) {
            dispatch(Internal.creators.sendMessage({
                payload: {
                    target: 'pico_arbiter',
                    ...Arbiter.creators.showPopup({
                        popupId: shortCode,
                        isOfferCodeActive: true,
                    }),
                },
            }))
        }
    }, [fetchedPopup, dispatch, shortCode])

    const fetchPopup = ({ shortCode: formShortCode } = {}) => {
        localDispatch({
            type: types.base,
            payload: { shortCode: formShortCode },
        })

        dispatch(Internal.creators.sendMessage({
            payload: {
                target: 'pico_arbiter',
                ...Arbiter.creators.fetchLoaderPopup({
                    popupId: formShortCode,
                }),
            },
        }))
    }

    return (
        <div
            className={styles.offerCode_container}
            style={{ color: linkColor }}
        >
            {!isVisible
                ? (
                    <div
                        aria-hidden
                        className={styles.offerCode_text}
                        onClick={() => {
                            localDispatch({ type: types.toggle })
                        }}
                    >
                        <span className="icon-discount" />
                        Enter offer code
                    </div>
                )
                : (
                    <RFForm
                        onSubmit={async (values) => {
                            fetchPopup(values)
                            await new Promise((re) => setTimeout(re, 1000))

                            if (!fetchedPopup) {
                                localDispatch({ type: types.error })
                                return { shortCode: 'Invalid offer code' }
                            }
                            return null
                        }}
                        initialValues={{
                            shortCode,
                        }}
                        render={({ handleSubmit, values, submitting }) => (
                            <form
                                onSubmit={handleSubmit}
                                className={styles.offerCode_form}
                            >
                                <div className={cx(styles.offerCode_input, {
                                    [styles['offerCode_input--error']]: error,
                                })}
                                >
                                    {/* eslint-disable-next-line max-len */}
                                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                    <label>Offer Code</label>
                                    <div>
                                        <Field
                                            name="shortCode"
                                            type="text"
                                            component={Form.Input}
                                            onChange={() => {
                                                if (error) {
                                                    localDispatch({ type: types.clearError })
                                                }
                                            }}
                                        />
                                        <Boutton
                                            buttonType="icon"
                                            style={{
                                                backgroundColor: linkColor,
                                                color: contrastColor,
                                            }}
                                            type="submit"
                                            disabled={!values?.shortCode || error || submitting}
                                        >
                                            <span className="icon-right" />
                                        </Boutton>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                )}
        </div>
    )
}

export default React.memo(OfferCode)
